// Import the functions you need from the SDKs you need

import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore"
import {getAuth} from "firebase/auth"
//import {getAnalytics} from "firebase/analytics"
import {getStorage} from "firebase/storage"



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyATXczK5s5zHYlO6CUwTPhnIzzoZiA4jf8",
  authDomain: "modernweb-6c211.firebaseapp.com",
  projectId: "modernweb-6c211",
  storageBucket: "modernweb-6c211.appspot.com",
  messagingSenderId: "190029401554",
  appId: "1:190029401554:web:66f8df080ed1e1d6444c0b",
  measurementId: "G-2YH7SYM276"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export const mydb=getFirestore(app)
export const auth=getAuth(app)
export const db=getFirestore(app)
//const analytics =getAnalytics(app);
var storage = getStorage(app)




export default storage;